import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap';
import  "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import { createApp } from 'vue';
import  App from './App.vue';
import mitt from 'mitt';
import axios from 'axios';
import router from './routes';
import { VueCookieNext } from 'vue-cookie-next';
import Maska from 'maska';
import VueSignature from "vue-signature-pad";
import VueApexCharts from "vue3-apexcharts";
import print from 'vue3-print-nb'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(fas)


const app = createApp(App);

app.config.globalProperties.$axios = axios;
app.use(router);
app.use(VueCookieNext);
app.use(Maska);
app.use(VueSignature);
app.use(VueApexCharts);
app.use(print)

VueCookieNext.config({ expire: '1y' })

app
    .component('fa', FontAwesomeIcon)
    .component('pad', VueSignature)
    .mount('#app');
app.provide('config');
